<mat-menu #menu="matMenu">
  <ng-container *ngFor="let item of items$ | async">
    <ng-container *ngIf="!item.subcategories?.length">
      <button mat-menu-item (click)="goToCategory(item)">
        {{ item.categoryName }}
      </button>
    </ng-container>
    <ng-container *ngIf="item.subcategories?.length">
      <button mat-menu-item [matMenuTriggerFor]="subMenu" (click)="goToCategory(item)">
        {{ item.categoryName }}
      </button>

      <mat-menu #subMenu="matMenu">
        <ng-container *ngFor="let sub of item.subcategories">
          <button mat-menu-item (click)="goToCategory(sub)">
            {{ sub.categoryName }}
          </button>
        </ng-container>
      </mat-menu>
    </ng-container>
  </ng-container>
</mat-menu>